import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';
import "../styles/index.css";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [hasBackdropFilter, setHasBackdropFilter] = useState(false);
    const hasBackgroundColor = false;
    const location = useLocation();

    // const targetElement = document.querySelector("#root");
    // useEffect(() => {
    //     if(isOpen) {
    //         disableBodyScroll(targetElement)
    //     } else {
    //         enableBodyScroll(targetElement)
    //     }

    //     return () => {
    //         clearAllBodyScrollLocks()
    //     }
    // }, [isOpen])

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            
            setHasBackdropFilter(scrollY > 100);
        };
    
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Always show scrollbar to prevent layout shift
    document.body.style.overflowY = "scroll"

    const isActiveLink = (path) => {
        if (path === '/' && location.pathname === '/') return true;
        if (path !== '/' && location.pathname.startsWith(path)) return true;
        return false;
    };

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="barfornav">
            <div className={`navbar-container ${hasBackdropFilter ? 'colored' : ''} ${hasBackgroundColor ? 'colored' : ''}`}>
                <div className='link'>
                    <Link to="/">
                        <div className="navbar-logo">
                            <img src="/logo.png" alt="Logo" className="logo-img" />
                            <span className="website-name">GIFT BAGS BY RACHAEL</span>
                        </div>
                    </Link>
                </div>
                <div className={`menu-links link ${!hasBackgroundColor && 'white-text'}`}>
                    <Link 
                        to="/brands" 
                        className={isActiveLink('/brands') ? 'active-link' : ''}
                    >
                        Brands
                    </Link>
                    <Link 
                        to="/events" 
                        className={isActiveLink('/events') ? 'active-link' : ''}
                    >
                        Events
                    </Link>
                    <Link 
                        to="/gallery" 
                        className={isActiveLink('/gallery') ? 'active-link' : ''}
                    >
                        Gallery
                    </Link>
                    <Link 
                        to="/press" 
                        className={isActiveLink('/press') ? 'active-link' : ''}
                    >
                        Press
                    </Link>
                    <Link 
                        to="/about" 
                        className={isActiveLink('/about') ? 'active-link' : ''}
                    >
                        About
                    </Link>
                    <Link 
                        to="/contact" 
                        className={isActiveLink('/contact') ? 'active-link' : ''}
                    >
                        Contact
                    </Link>
                </div>
                <div className={`hamburger ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </div>

            <div className={`nav-backdrop ${isOpen ? 'open' : ''}`} onClick={toggleMenu} />

            <div className={`sideNavMenu ${isOpen ? 'open' : ''}`}>
                <div className='links link flexCol alignCenter justifyCenter'>
                    <Link 
                        onClick={toggleMenu} 
                        to="/brands"
                        className={isActiveLink('/brands') ? 'active-link' : ''}
                    >
                        <h3>Brands</h3>
                    </Link>
                    <Link 
                        onClick={toggleMenu} 
                        to="/events"
                        className={isActiveLink('/events') ? 'active-link' : ''}
                    >
                        <h3>Events</h3>
                    </Link>
                    <Link 
                        onClick={toggleMenu} 
                        to="/gallery"
                        className={isActiveLink('/gallery') ? 'active-link' : ''}
                    >
                        <h3>Gallery</h3>
                    </Link>
                    <Link 
                        onClick={toggleMenu} 
                        to="/press"
                        className={isActiveLink('/press') ? 'active-link' : ''}
                    >
                        <h3>Press</h3>
                    </Link>
                    <Link 
                        onClick={toggleMenu} 
                        to="/about"
                        className={isActiveLink('/about') ? 'active-link' : ''}
                    >
                        <h3>About</h3>
                    </Link>
                    <Link 
                        onClick={toggleMenu} 
                        to="/contact" 
                        className={isActiveLink('/contact') ? 'active-link' : ''}
                    >
                        <h3>Contact</h3>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
